import { ReactNode } from 'react';

import Text from '../base/Text';

export default function PanelSection({
  title,
  content,
}: {
  title: string;
  content: Array<{ title?: string; children: ReactNode }>;
}) {
  return (
    <div>
      <div className="mb-2 flex h-[34px] items-center">
        <Text variant="studio/body/medium/sm" as="h2">
          {title}
        </Text>
      </div>
      <div className="border-gray-30 dark:border-gray-60 divide-gray-30 dark:divide-gray-60 flex flex-col divide-y rounded-2xl border px-4 py-6">
        {content.map((item, index) => (
          <div
            key={(item.title || '') + index}
            className="pb-6 pt-6 first:pt-0 last:pb-0"
          >
            {item.title && (
              <Text
                as="h3"
                variant="studio/body/medium/sm"
                className="text-gray-60 dark:text-gray-30 mb-4"
              >
                {item.title}
              </Text>
            )}
            {item.children}
          </div>
        ))}
      </div>
    </div>
  );
}
